export default __webpack_public_path__ + "static/media/google-play.8fcf7d28.png";